import React from 'react';
import { connect } from 'react-redux';
import configuration from '../../constants/Configuration';
import videoUtils from '../utils/VideoUtils';
import storeManager from '../../store/StoreManager';
import properties from '../../constants/Properties';

const TotalDurationViewContent = React.createClass({
    render() {
        const width = this.props.buttonSize * 2;
        const height = properties.PREVIEW_HEIGHT;

        const timeButtonStyle = {
            position: 'absolute',
            left: configuration.CANVAS_WIDTH * this.props.scaleProperties.scale / 2 - width / 2,
            top: this.props.windowHeight - height - this.props.scaleProperties.topY,
            width: width,
            height: height,
            background: 'white',
            userDrag: 'none',
            WebkitUserSelect: 'none',
            userSelect: 'none'
        };

        var offset = 1;
        const timeStyle = {
            position: 'absolute',
            top: 12,
            left: offset,
            color: '#272727',
            fontSize: 22,
            width: width - 2 * offset,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default',
            textAlign: 'center'
        };

        return (
            <div style={timeButtonStyle}>
                <span style={timeStyle}>{videoUtils.getEditVideoDuration()}</span>
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    const updateValue = state.menu.updateValue;

    return {
        updateValue
    };
}

export const TotalDurationView = connect(mapStateToProps)(TotalDurationViewContent);



/** WEBPACK FOOTER **
 ** ./src/components/videoEditor/TotalDurationView.js
 **/